import {
  IonIcon,
  IonItem,

  IonModal,
  IonButton,
  IonText,
} from "@ionic/react";
import { brushOutline } from "ionicons/icons";
import React, { useState } from "react";
import "./AICRecommender.css";

function AICRecommender() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <IonItem className="ion-hide-sm-up">
        <IonIcon icon={brushOutline} slot="start" className="ion-icon" />

        <IonModal isOpen={showModal} className="ion-modal-popup">
          <IonText className="ion-justify-content-center ion-align-items-center ion-margin">
            <br />
            <b>Art Institute of Chicago Recommender System</b>
            <br />
            <p>
              I'm currently building a collaborative filtering recommender
              system in <code>Ruby on Rails</code> to personalize recomendations
              for artwork using the Art Institute of Chicago's API.
            </p>

            <em>Demo coming soon!</em>
            <br />
            <IonButton
              className="ion-button"
              onClick={() => setShowModal(false)}
            >
              Close
            </IonButton>

            <br />
          </IonText>
        </IonModal>

        <IonButton className="ion-button" onClick={() => setShowModal(true)}>
          Show
        </IonButton>
      </IonItem>
    </div>
  );
}

export default AICRecommender;
